export default __webpack_public_path__ + "static/media/header_web.38f4bfc8.webp";